import { render, staticRenderFns } from "./channel_list.vue?vue&type=template&id=74511023&scoped=true"
import script from "./channel_list.vue?vue&type=script&lang=js"
export * from "./channel_list.vue?vue&type=script&lang=js"
import style0 from "./channel_list.vue?vue&type=style&index=0&id=74511023&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74511023",
  null
  
)

export default component.exports